import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Collapse, Fade } from '@mui/material';
import type { NormalizedError } from '../../constants/errorCodes';
import { hasUsableAction } from '../../utils/errorActionHandler';

type Props = {
  error: NormalizedError | null;
  onAction: (action: NormalizedError['action']) => void;
};

const TRANSITION_MS = 250;

const KLInlineError: React.FC<Props> = ({ error, onAction }) => {
  // Keep the last non-null error so the content remains rendered during the
  // exit animation — otherwise it would vanish mid-collapse.
  const [displayError, setDisplayError] = useState<NormalizedError | null>(error);

  useEffect(() => {
    if (error) setDisplayError(error);
  }, [error]);

  return (
    <Collapse in={!!error} timeout={TRANSITION_MS} appear>
      <Fade in={!!error} timeout={TRANSITION_MS} appear>
        <Box
          role="alert"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            my: 3,
            p: 1.5,
            borderRadius: 1.5,
            bgcolor: 'rgba(239, 68, 68, 0.08)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
          }}
        >
          {displayError && (
            <>
              <Typography variant="body2" color="error" sx={{ fontWeight: 500 }}>
                {displayError.message}
              </Typography>
              {hasUsableAction(displayError.action) && (
                <Button
                  size="small"
                  variant="contained"
                  color="error"
                  fullWidth
                  onClick={() => onAction(displayError.action)}
                >
                  {displayError.action.label}
                </Button>
              )}
            </>
          )}
        </Box>
      </Fade>
    </Collapse>
  );
};

export default KLInlineError;
